import React from 'react';
import { Form, Input, Button, Tree, message } from 'antd';

export default () => {
    const urlParams = new URLSearchParams(window.location.search);
    const [permissions, setPermissions] = React.useState([]);
    const [selectedPermissions, setSelectedPermissions] = React.useState([]);
    const [form] = Form.useForm();

    const getPermissionsTree = async () => {
        const response = await fetch('/api/account/permissions-tree');
        const result = await response.json();

        if (result && result.success) {
            result.data = result.data.map(item => {
                return {
                    ...item,
                    title: item.name,
                    key: `group-${item.groupId}`,
                    children: item.sys_permission_pk_groups.map(child => {
                        return {
                            ...child,
                            title: child.permission.title,
                            key: child.permission.perId,
                            perId: child.permission.perId,
                        }
                    })
                }
            });
            setPermissions(result.data);
        }
    }

    // 获取角色信息
    const getRoleInfo = async () => {
        const roleId = urlParams.get('roleId');
        if (roleId) {
            const response = await fetch(`/api/account/role/detail?roleId=${roleId}`);
            const result = await response.json();

            if (result && result.success) {
                console.log('result', result);
                const { roleTitle, perId_sys_permissions } = result.data;
                const permissionIds = perId_sys_permissions.map(item => item.perId);
                form.setFieldsValue({
                    roleTitle,
                    permissionIds,
                });
                setSelectedPermissions(permissionIds);
            }
        }
    }

    React.useEffect(() => {
        getPermissionsTree();
        getRoleInfo();
    }, []);

    const onPermissionCheck = (checkedKeys, info) => {
        // console.log('checkedKeys', checkedKeys, info);
        const { checkedNodesPositions } = info;

        const checked = [];
        checkedNodesPositions.forEach(item => {
            const { node, pos } = item;
            if (pos.split('-').length === 3) {
                checked.push(node.perId);
            }
        });
        // console.log('checked', checked);
        setSelectedPermissions(checked);
        form.setFieldsValue({
            permissionIds: checked,
        });
    }

    const onSubmit = () => {
        form.validateFields().then(async values => {
            // values.permissionIds = selectedPermissions;
            console.log('values', values);
            const roleId = urlParams.get('roleId');
            const url = roleId ? `/api/account/role/edit?roleId=${roleId}` : `/api/account/role/create`;
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            });

            const result = await response.json();

            if (result.success) {
                message.success('提交成功');
                setTimeout(() => {
                    window.location.href = '/account/role';
                }, 1000);
            } else {
                message.error(result.data);
            }
        }).catch(errorInfo => {
            console.log('Failed:', errorInfo);
        });
    }
        
    return (
        <div>
            <h2 className="admin-page-title">{urlParams.get('roleId') ? '编辑角色' : '创建角色'}</h2>
            
            <div className="admin-form-container">
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="角色名"
                        name='roleTitle'
                        rules={[{ required: true, message: '请输入角色名' }]}
                    >
                        <Input className="admin-form-input" placeholder="请输入角色名称" />
                    </Form.Item>

                    <Form.Item
                        label="权限点"
                        name='permissionIds'
                        rules={[{ required: true, message: '请选择权限' }]}
                    >
                        <Tree 
                            onCheck={onPermissionCheck} 
                            checkedKeys={selectedPermissions} 
                            treeData={permissions} 
                            checkable 
                            autoExpandParent={true} 
                            className="border border-gray-200 rounded p-3 max-h-[400px] overflow-y-auto"
                        />
                    </Form.Item>
                </Form>
                
                <div className="admin-form-actions">
                    <Button onClick={() => window.location.href = '/account/role'}>
                        取消
                    </Button>
                    <Button type="primary" onClick={onSubmit}>
                        提交
                    </Button>
                </div>
            </div>
        </div>
    );
};